Object.assign(window.labelToSkuPartMap = window.labelToSkuPartMap || {}, {
  "ALBERTA": "AB",
  "BRITISH COLUMBIA": "BC",
  "MANITOBA": "MB",
  "NEW BRUNSWICK": "NB",
  "NEWFOUNDLAND AND LABRADOR": "NL",
  "NORTHWEST TERRITORIES": "NW",
  "NOVA SCOTIA": "NS",
  "NUNAVUT": "NV",
  "ONTARIO": "ON",
  "PRINCE EDWARD ISLAND": "PE",
  "QUEBEC": "QB",
  "SASKATCHEWAN": "SK",
  "YUKON": "YK"
});

// Create a dedicated province mapping object
Object.assign(window.provinceToSkuPartMap = window.provinceToSkuPartMap || {}, {
  "ALBERTA": "AB",
  "BRITISH COLUMBIA": "BC",
  "MANITOBA": "MB",
  "NEW BRUNSWICK": "NB",
  "NEWFOUNDLAND AND LABRADOR": "NL",
  "NORTHWEST TERRITORIES": "NW",
  "NOVA SCOTIA": "NS",
  "NUNAVUT": "NV",
  "ONTARIO": "ON",
  "PRINCE EDWARD ISLAND": "PE",
  "QUEBEC": "QB",
  "SASKATCHEWAN": "SK",
  "YUKON": "YK"
});